// Mapeamento manual: description bruta do control object (banco) → rótulo
// bonito mostrado na tela de seleção de turma. Turma sem entrada aqui cai no
// texto original vindo do backend — atualize esse mapa quando criar/renomear
// um control object.
const TURMA_LABELS: Record<string, string> = {
  'FAG - Turma 2026.1': 'FAG - 2026',
  'FAG - 8º Período 2026': 'FAG - 8º Período/2026'
};

export function getTurmaLabel(description: string): string {
  return TURMA_LABELS[description] ?? description;
}
